import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=e96c64be&scoped=true&"
import script from "./InputField.vue?vue&type=script&lang=ts&"
export * from "./InputField.vue?vue&type=script&lang=ts&"
import style0 from "./InputField.vue?vue&type=style&index=0&id=e96c64be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96c64be",
  null
  
)

export default component.exports